import { PRO_PLAYERS } from '@/components/trial/shared/pro-players';

export const SPACE_BLACK = '#0A0A12';
export const SABER_BLUE = '#4FC3F7';
export const SABER_GREEN = '#93FF18';
export const EMPIRE_RED = '#FF3B3B';
export const HOLO_BORDER = '#4FC3F740';
export const HOLO_BG = '#4FC3F708';
export const STAR_GRAY = '#929298';
export const TEXT_LIGHT = '#E5E7EB';

export const EASE_OUT = [0.25, 0.46, 0.45, 0.94] as const;
export const EASE_IN_OUT = [0.42, 0, 0.58, 1] as const;

export const SW_TOOLS_COUNT = 6;

export const PRO_ENDORSEMENTS = [PRO_PLAYERS.sacy, PRO_PLAYERS.coldzera, PRO_PLAYERS.brtt, PRO_PLAYERS.suja, PRO_PLAYERS.arkane, PRO_PLAYERS.lestripez] as const;

export const GAME_IMAGES = [
  { name: 'CS2', file: 'cs2.webp' },
  { name: 'Valorant', file: 'valorant.webp' },
  { name: 'Fortnite', file: 'fortnite.webp' },
  { name: 'Dota 2', file: 'dota2.webp' },
  { name: 'League of Legends', file: 'lol.webp' },
  { name: 'World of Warcraft', file: 'wow.webp' },
  { name: 'Overwatch 2', file: 'overwatch2.webp' },
  { name: 'Apex Legends', file: 'apex.webp' },
  { name: 'PUBG', file: 'pubg.webp' },
  { name: 'Rocket League', file: 'rocket-league.webp' },
  { name: 'Rainbow Six Siege', file: 'r6siege.webp' },
  { name: 'Tibia', file: 'tibia.webp' },
  { name: 'Call of Duty', file: 'cod.webp' },
] as const;
